<gdl-modal></gdl-modal>
<gdl-notification-v2 />
<div class="content d-flex flex-row w-100">
  <div id="sidebar" class="d-flex flex-column w-10px bg-secondary text-white">
  </div>
  <div class="w-100 h-100">
    <router-outlet></router-outlet>
  </div>
</div>